<template>
  <div id="ag-grid-demo" v-if="showWindow">
    <div class="vx-col w-full mb-base">
			<vx-card title="Filter" code-toggler>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Month</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input-number v-model="month" min="1" max="12"/>
              </div>
            </div>
					</div>
					<div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-button class="mr-3 mb-2" @click="setData">Submit</vs-button>						
            <vs-button color="warning" type="border" class="mr-3 mb-2" @click="download(false)">Download</vs-button>
            <vs-button color="danger" type="border" class="mr-3 mb-2" @click="download(true)">Download all</vs-button>
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col sm:w-1/2 w-full mb-2">
						<div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Year</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input-number v-model="year" />
              </div>
            </div>
					</div>
				</div>			
    </vx-card>
  </div>
    <vx-card>
      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center">

        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ tableData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : tableData.length }} of {{ tableData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
        </div>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="tableData"
        rowSelection="multiple"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage" />

    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import axios from "@/axios.js"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
export default {
  components: {
    AgGridVue
  },
  data() {
    let d = new Date();
    return {
      searchQuery: '',
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      tableData:[],
      month:d.getMonth()+1,
      year: d.getFullYear(),
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'tran_type',
          field: 'tran_type',
          width: 125,
          filter: true,
        },
        
        {
          headerName: 'deposit_date',
          field: 'deposit_date',
          filter: true,
          width: 175,
        },
        {
          headerName: 'user_id',
          field: 'user_id',
          filter: true,
          width: 125,
        },
        {
          headerName: 'client_details',
          field: 'client_details',
          filter: true,
          width: 250,
        },
        {
          headerName: 'balance_due',
          field: 'balance_due',
          filter: true,
          width: 150,
        },
        {
          headerName: 'invoice_number',
          field: 'invoice_number',
          filter: true,
          width: 150,
        },
        {
          headerName: 'quantity',
          field: 'quantity',
          filter: true,
          width: 125,
        },
        {
          headerName: 'rate',
          field: 'rate',
          filter: true,
          width: 125,
        },
        {
          headerName: 'amount',
          field: 'amount',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'commi',
          field: 'commi',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'subtotal',
          field: 'subtotal',
          filter: true,
          width: 125,
        },
        {
          headerName: 'status_name',
          field: 'status_name',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'transaction_id',
          field: 'transaction_id',
          filter: true,
          width: 125,
        },
        {
          headerName: 'created_at',
          field: 'created_at',
          filter: "agNumberColumnFilter",
          width: 125,
        },
        {
          headerName: 'action',
          field: 'action',
          width: 125,
          cellRenderer: function(params) {
            return params.value
          }
        }       
      ],
    }
  },
  computed: {
    showWindow(){
      if(this.$route.path==='/invoices'){
        if(this.tableData.length===0)
          this.setData();
        return true;
      }
      return false;
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 50
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    setData: function(){
        const params = new URLSearchParams();
        let month = this.month>9 ? this.month : '0'+this.month;
        params.append('form', 'yeat='+this.year+'&month='+month);
      axios.post("/api/invoices",params)
        .then((response) => {
          this.tableData.splice(0);
          let month = this.month>9 ? this.month : '0'+this.month;
          for(let i in response.data){
            let data = response.data[i];
            let url = encodeURI(data.client_details);
            data.action = '<a class="btn btn-primary btn-xs" target="_blank" href="/invoices_tech/evblock/'+this.year+'/'+month+'/'+url+'-'+data.transaction_id+'.pdf">View';
            this.tableData.push(data);
          }
        })
        .catch(() => { })
    },
    download: function(all){
      if(all){
        window.location.href = '/invoices_tech/evblock/allInvoices.zip';
        return false;
      }
      let month = this.month>9 ? this.month : '0'+this.month;
      window.location.href = '/invoices_tech/evblock/'+this.year+'/'+month+'/invoices.zip';
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  }
}

</script>
